import { render, staticRenderFns } from "./StepB.vue?vue&type=template&id=7f9132b0&scoped=true&"
import script from "./StepB.vue?vue&type=script&lang=js&"
export * from "./StepB.vue?vue&type=script&lang=js&"
import style0 from "./StepB.vue?vue&type=style&index=0&id=7f9132b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9132b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
